import { computed, watch } from "vue";
import { i as isServer } from "../../../utils/ssr-fd33979c.mjs";
import { j as cssVariableName } from "../utils-e7c3fc9a.mjs";
import { g as generateUniqueId } from "../../../utils/uuid-7d2e5892.mjs";
import { a as addOrUpdateStyleElement } from "../../../utils/dom-ddcff6c3.mjs";
import { u as useColors } from "../../../composables/useColors-6d98be99.mjs";
const generateCSSVariable = (key, value) => {
  return `${cssVariableName(key)}: ${value};
`;
};
const createColorConfigPlugin = (app, config) => {
  const { colors: configColors, getTextColor, getColor, currentPresetName, applyPreset } = useColors();
  const renderCSSVariables = (colors = configColors) => {
    if (!colors) {
      return;
    }
    const colorNames = Object.keys(colors);
    const renderedColors = colorNames.map((key) => `${cssVariableName(key)}: ${colors[key]}`).join(";");
    const renderedOnColors = colorNames.map((key) => `${cssVariableName(`on-${key}`)}: ${getColor(getTextColor(colors[key]))}`).join(";");
    return `${renderedColors};${renderedOnColors}`;
  };
  const renderCSSVariablesStyleContent = (colors = configColors) => {
    const colorNames = Object.keys(colors);
    let result = ":root {\n";
    colorNames.forEach((key) => {
      result += generateCSSVariable(key, colors[key]);
    });
    colorNames.forEach((key) => {
      result += generateCSSVariable(`on-${key}`, getColor(getTextColor(colors[key])));
    });
    result += "}\n";
    return result;
  };
  const uniqueId = computed(generateUniqueId);
  const updateColors = (newValue) => {
    if (!newValue) {
      return;
    }
    if (isServer()) {
      return;
    }
    const styleContent = renderCSSVariablesStyleContent(newValue);
    addOrUpdateStyleElement(`va-color-variables-${uniqueId.value}`, () => styleContent);
  };
  watch(configColors, (newValue) => {
    updateColors(newValue);
  }, { immediate: true, deep: true });
  return {
    colors: configColors,
    currentPresetName,
    renderCSSVariables,
    updateColors,
    renderCSSVariablesStyleContent
  };
};
export {
  createColorConfigPlugin as c
};
//# sourceMappingURL=create-color-config-plugin-7ed9b9e2.mjs.map
